import script from "./InvestigationGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestigationGeneral.vue?vue&type=script&setup=true&lang=js"

import "./InvestigationGeneral.vue?vue&type=style&index=0&id=04aad9b6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04aad9b6"]])

export default __exports__